export default __webpack_public_path__ + "static/media/Columbia-Regular.bcb561ff.ttf";